module.exports = __webpack_public_path__ + "static/inspospotr-hero-min-587fb4bcb8b0647470b5affafb0c9ae6.jpg";